import React, { useState, useEffect, ChangeEvent } from 'react';
import './HomePage.css';
import blackAppleLogo from './assets/blackapplelogo.png'
import ReportGenerator from './tiles/ReportGenerator';
import FeasibilityCalculator from './tiles/FeasibilityCalculator';
import CreativeLibrary from './tiles/CreativeLibrary';
import TVCreativeTracker from './tiles/TV+CreativeTracker'
import PhonePerfDashboard from './tiles/iPhonePerfDashboard'
import SignificanceCalculator from './tiles/ABTestingCalculator'
import { useAuth } from './oktaContext';

// Retrieve data
const accessToken = sessionStorage.getItem('accessToken');
const name = sessionStorage.getItem('name')?.slice(1,-1);

interface CardProps {
  id: number;
  enabled: boolean;
  title: string;
  description: string;
  category: string;
  categoryColor: string;
  onClick: (id: number) => void;
}

interface CardData {
  id: number;
  enabled: boolean;
  title: string;
  description: string;
  category: string;
  categoryColor: string;

}

const HomePage: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('All Categories');
  const [enabledCards, setEnabledCards] = useState<boolean>(false);
  const [reportModalIsOpen, setReportModalIsOpen] = useState<boolean>(false);
  const [feasibilityModalIsOpen, setFeasibilityModalIsOpen] = useState<boolean>(false);
  const [creativeLibraryModalIsOpen, setCreativeLibraryModalIsOpen] = useState<boolean>(false);
  const [TVCreativeTrackerModalIsOpen, setTVCreativeTrackerModalIsOpen] = useState<boolean>(false);
  const [iPhonePerfDashboardIsOpen, setiPhonePerfDashboardIsOpen] = useState<boolean>(false);
  const [significanceModalIsOpen, setSignificanceModalIsOpen]  = useState<boolean>(false)
  const { logout } = useAuth();

  const closeModal = () => {
    setReportModalIsOpen(false);
    setFeasibilityModalIsOpen(false);
    setCreativeLibraryModalIsOpen(false);
    setTVCreativeTrackerModalIsOpen(false);
    setiPhonePerfDashboardIsOpen(false);
    setSignificanceModalIsOpen(false);
  };

  useEffect(() => {
  }, [name, enabledCards]);

  const handleCardClick = (id: number) => {
    if (id === 1) {
      setFeasibilityModalIsOpen(true);
    } else if (id == 2) {
      window.open('https://gbitableauprod.corp.apple.com/views/PaidTestResultsDashboard/SummaryStats', '_blank');
    } else if (id === 3) {
      setReportModalIsOpen(true);
    } else if (id == 4) {
      setTVCreativeTrackerModalIsOpen(true);
    } else if(id === 5) {
      setiPhonePerfDashboardIsOpen(true);
    }else if (id === 6) {
      setCreativeLibraryModalIsOpen(true);
    } else if (id = 7 ) {
      setSignificanceModalIsOpen(true);
    }
  };

  const handleEnabledButtonClick = () => {
    setEnabledCards(!enabledCards)
  }

  const handleCategoryChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setSelectedCategory(e.target.value);
  };

  const cardsData: CardData[] = [
    { id: 1, enabled: true, title: 'Feasibility Calculator', description: "Provide guardrails for versioning feasibility in Test design. Supports scenario planning especially during rush timelines.", category: 'Test & Learn' , categoryColor: '#5856D6'},
    { id: 2, enabled: true, title: 'Learning Library', description: "A comprehensive inventory of tests across regions, pillars, and categories. Access to this library requires Apple Connect and a Tableau license.", category: 'Test & Learn', categoryColor: '#5856D6'},
    { id: 3, enabled: true, title: 'Report Generator',  description: "Generate template Keynote reports with most recent Performance metrics.", category: 'Reports', categoryColor: '#AF52DE' },
    { id: 4, enabled: true, title: 'TV+ Creative Tracker', description: "Track placements that have aired and review creatives that went live.", category: 'Reports', categoryColor: '#AF52DE' },
    { id: 5, enabled: true, title: 'iPhone Performance', description: "Review latest results and trends across Switchers, Upgraders, Trade In and Carrier.", category: 'Reports', categoryColor: '#AF52DE' },
    { id: 6, enabled: true, title: 'Creative Library', description : "Search & Filter through past Creative assets trafficked by pillar and category.", category: 'Campaigns', categoryColor: '#FF2D55' },
    { id: 7, enabled: true, title: 'Statistical Significance Calc', description : "Enter your campaign results to see if they have a statistical likelihood to be repeatable.", category: 'Test & Learn', categoryColor: '#5856D6' },
    { id: 8, enabled: false, title: 'Submit Learnings', description: "Add learnings from Tests, Research and Trends to share with Apple.", category: 'Test & Learn', categoryColor: '#5856D6' },
    { id: 9, enabled: false, title: 'Import Tests', description: "Upload export of Test tickets from Jira.", category: 'Test & Learn', categoryColor: '#5856D6'},
    { id: 10, enabled: false, title: 'Archive Celtra Assets', description: "Push approved final variants to Box.com for archiving.", category: 'Production', categoryColor: '#007AFF'},
    { id: 11, enabled: false, title: 'Content Matrix (Standard)', description: "Upload a media asset list and output a production-ready content matrix", category: 'Production', categoryColor: '#007AFF' },
    { id: 12, enabled: false, title: 'Content Matrix (Price Refresh)', description: "Upload a media asset list and output a production-ready content matrix", category: 'Production', categoryColor: '#007AFF' },
    { id: 13, enabled: false, title: 'Export Confluence Content', description: "Pull Copy & Legal tracker content directly into production-ready content matrix.", category: 'Production', categoryColor: '#007AFF' },
    { id: 14, enabled: false, title: 'Validate Creative Taxonomy', description: "Run MAL Pipeline naming convention validation checks from content matrix.", category: 'Production', categoryColor: '#007AFF' },
    { id: 15, enabled: false, title: 'Export Creative Taxonomy', description: "Create an export from MAL Pipeline to feed into Taxonomy Builder.", category: 'Operations', categoryColor: '#30B037' },
  ];

const filteredCards = cardsData.filter(card => {
  const categoryMatch = selectedCategory === 'All Categories' || card.category === selectedCategory;
  const enabledMatch = enabledCards ? card.enabled : true;
  return categoryMatch && enabledMatch;
});

  return (
    <div className="App">
      <ReportGenerator isOpen={reportModalIsOpen} onRequestClose={closeModal} />
      <FeasibilityCalculator isOpen={feasibilityModalIsOpen} onRequestClose={closeModal} />
      <CreativeLibrary isOpen={creativeLibraryModalIsOpen} onRequestClose={closeModal} />
      <TVCreativeTracker isOpen={TVCreativeTrackerModalIsOpen} onRequestClose={closeModal} />
      <PhonePerfDashboard isOpen={iPhonePerfDashboardIsOpen} onRequestClose={closeModal} />
      <SignificanceCalculator isOpen={significanceModalIsOpen} onRequestClose={closeModal} />
      <header className="App-header">
        <div className="App-title" onClick={() => window.location.reload()}>
          <img src={blackAppleLogo} alt="Apple Logo" className="logo" />
          <h2>Performance Operations Hub</h2>
        </div>
        <div className="App-settings">
          <div className='nameTitle'>
            <h3 className='name'>{name}</h3>
          </div>
            <div>
              <button className="logout" onClick={logout}>Sign out</button>
            </div>
        </div>
      </header>
      <main className="App-body">
        <div className="body-container">
        <div className='filter-container'>
          <nav className="Category-filter">
            <select className='category-select' value={selectedCategory} onChange={handleCategoryChange}>
              <option>All Categories</option>
              <option>Test & Learn</option>
              <option>Production</option>
              <option>Reports</option>
              <option>Campaigns</option>
              <option>Operations</option>
            </select>
          </nav>
          <button className={`${enabledCards ? 'enabled-button' : 'enabled-button-selected'}`}onClick={handleEnabledButtonClick}>Enabled</button>
        </div>
        <div className="Card-container">
          {filteredCards.map(card => (
             <Card key={card.id} {...card} onClick={handleCardClick} />
          ))}
        </div>
        </div>
      </main>
      <footer className="footer"></footer>
    </div>
  );
};

const Card: React.FC<CardProps> = ({ id, enabled, title, description, category, categoryColor, onClick }) => {
  return (
    <div className={`Card ${enabled ? '' : 'Card-disabled'}`} onClick={() => onClick(id)}>
      <div className="Category" style={{color: categoryColor}}>{category}</div>
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  );
};

export default HomePage;
